import * as React from 'react';
// Import props.
import {
	AppSectionProps,
} from '@app/props';

export default class AppSectionData<TSectionProps extends AppSectionProps<TSectionName>, TSectionName extends string> {
	public section?: React.ComponentType<TSectionProps>;
	public backSection?: TSectionName;
	public forwardSection?: TSectionName;

	public constructor(section: React.ComponentType<TSectionProps> | undefined = undefined, backSection: TSectionName | undefined = undefined, forwardSection: TSectionName | undefined = undefined) {
		this.section = section;
		this.backSection = backSection;
		this.forwardSection = forwardSection;
	}
};